import styledComponents from 'styled-components'
export const NewImageBackground = styledComponents.div`
    background-image: url(${props => props.img});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: top;
`
